export const FETCH_SUBMITTED_FOR_VERIFICATION_VISITS = "[TYPIST] FETCH_SUBMITTED_FOR_VERIFICATION_VISITS";
export const FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_START = "[TYPIST] FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_START";
export const FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_SUCCESS = "[TYPIST] FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_SUCCESS";
export const FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_ERROR = "[TYPIST] FETCH_SUBMITTED_FOR_VERIFICATION_VISITS_ERROR";

export const VIEW_SUBMITTED_FOR_VERIFICATION_VISIT = "[TYPIST] VIEW_SUBMITTED_FOR_VERIFICATION_VISIT";
export const VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START = "[TYPIST] VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START";
export const VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS = "[TYPIST] VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS";
export const VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR = "[TYPIST] VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR";

export const LOCK_SUBMITTED_FOR_VERIFICATION_VISIT = "[TYPIST] LOCK_SUBMITTED_FOR_VERIFICATION_VISIT";
export const LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_START = "[TYPIST] LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_START";
export const LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS = "[TYPIST] LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS";
export const LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR = "[TYPIST] LOCK_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR";

export const UNLOCK_SUBMITTED_FOR_VERIFICATION_VISIT = "[TYPIST] UNLOCK_SUBMITTED_FOR_VERIFICATION_VISIT";
export const UNLOCK_SUBMITTED_FOR_VERIFICATION_VISIT_START = "[TYPIST] UNLOCK_SUBMITTED_FOR_VERIFICATION_VISIT_START";
export const UNLOCK_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS = "[TYPIST] UNLOCK_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS";
export const UNLOCK_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR = "[TYPIST] UNLOCK_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR";

export const SET_SUBMITTED_FOR_VERIFICATION_SEARCH_FILTER_AND_SORT = "SET_SUBMITTED_FOR_VERIFICATION_SEARCH_FILTER_AND_SORT";
export const SET_SUBMITTED_FOR_VERIFICATION_VISIT_PAGINATION = "[TYPIST] SET_SUBMITTED_FOR_VERIFICATION_VISIT_PAGINATION";

export const RESET_SUBMITTED_FOR_VERIFICATION_VISIT_FILTER = "[TYPIST] RESET_SUBMITTED_FOR_VERIFICATION_VISIT_FILTER";
export const setSubmittedForVerificationSearchFilterAndSort = (searchFilter, sortConditions) => {
    return {
        type: SET_SUBMITTED_FOR_VERIFICATION_SEARCH_FILTER_AND_SORT,
        payload: {
            searchFilter,
            sortConditions
        }
    };
}

export const getSubmittedForVerificationVisits = (payload) => {
    return {
        type: FETCH_SUBMITTED_FOR_VERIFICATION_VISITS,
        payload
    };
};

export const viewSubmittedForVerificationVisit = (visit) => {
    return {
        type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT,
        visit
    };
}

export const resetSFVFilter = () => {
    return {
        type: RESET_SUBMITTED_FOR_VERIFICATION_VISIT_FILTER,
    };
}